import React from 'react';
import { Typography, Grid } from '@material-ui/core'
import './main.css';
import waves from '../images/WAVES.png';
import gif from './images/GIF.webm';
import AppearingElement from "../Helper/AppearingElement";

function Slide() {
    return (
        <div className="slide-salesForce" >
            <img src={waves} alt="" className="slide__waves-salesForce" />
            <Grid container
                spacing={1}
                direction="row"
                justify="space-around"
                alignItems="flex-start">
                <Grid item xs={12} sm={12} md={5} className="slide-grid-container">
                    <AppearingElement variant="zoom-down">
                        <Typography className="slide__main-text-salesForce" variant="h3" >Reimagine the Possibilities!</Typography>
                    </AppearingElement>
                    <AppearingElement variant="zoom-down">
                        <Typography className="slide__sub-text-salesForce" variant="subtitle1" >Ziplyne enables you and your company to navigate Salesforce to its fullest, without the need to consistently rely on an outside implementation partner or in-house training and support teams.</Typography>
                    </AppearingElement>
                </Grid>
                <Grid item xs={8} sm={8} md={5}>
                    <video src={gif} className="slide__video-salesForce" autoPlay loop muted playsInline />
                </Grid>
            </Grid>
        </div>
    )
}

export default Slide